import React from 'react'
import { withCounter } from '../../hocs'

const InputCounter = ({ incrementCount, count, label }) => (
  <div className="input-field col s3">
    <input
      onFocus={incrementCount}
      type="text"
      placeholder={`Focuses ${count} times`}
    />
    <label>{label}</label>
  </div>
)

export default withCounter(InputCounter)
